import { NavigateFunction } from 'react-router'
import { SecondaryNavigationMenu } from '@reapit-sales/navigation'
import { navigateRoute } from '@reapit-sales/utilities'
import { buildOfficePageURL } from '@crm/components/office/buildOfficePageURL'
import { NAV_MENU, NavTitle } from '@crm/core/constants'
import { SettingsIcon } from '@reapit/elements/icons/settings'

/**
 * `getMyOfficesMenu` generates a "My Office" menu item that navigates to the office page.
 *
 * Props:
 * @param navigate (NavigateFunction): The navigation function used to redirect the user to a different route.
 *
 * Returns:
 * (SecondaryNavigationMenu): A "My Office" menu item with a `settings` icon, which triggers navigation
 * to the office page.
 *
 * This function:
 * 1. Creates a "My Office" menu item with the `settings` icon.
 * 2. Calls `navigateRoute` to navigate the user to the office page by invoking `buildOfficePageURL`.
 */
export const getMyOfficesMenu = (
  navigate: NavigateFunction,
  legacyCRMIframePageName: string,
): SecondaryNavigationMenu => ({
  label: NAV_MENU.MYOFFICE as NavTitle,
  icon: <SettingsIcon />,
  onClick: navigateRoute(navigate, buildOfficePageURL(), NAV_MENU.MYOFFICE as NavTitle, legacyCRMIframePageName),
  href: buildOfficePageURL(),
})
